<template>
  <a-form-model
    v-if="form"
    layout="horizontal"
    ref="form"
    class="flex gap-6"
    :model="form"
    :rules="rules"
    :label-col="{ span: 24 }"
    :wrapper-col="{ span: 24 }"
  >
    <div class="flex flex-column gap-3">
      <span>{{ template.sub_title }}</span>
      <div class="flex flex-column gap-2" v-for="item in template.info" :key="item.title">
        <h3>{{ item.title }}</h3>
        <span v-for="(element, idx) in item.text" :key="idx"> - {{ element }} </span>
      </div>
      <div v-for="section in template.sections" :key="section.title" class="flex flex-column gap-2">
        <h3>{{ section.title }}</h3>

        <div v-for="question in section.questions" :key="question.id" class="flex flex-column gap-2">
          <a-form-model-item
            :colon="false"
            label-align="left"
            :label="question.title"
            :prop="question.id.toString()"
            :help="question.description"
          >
            <a-input
              v-if="question.type === 'text'"
              v-model="form[question.id.toString()]"
              placeholder="Type something"
            />
            <custom-select
              v-else-if="question.type === 'multi_select' || question.type === 'single_select'"
              :multiple="question.type === 'multi_select'"
              :value.sync="form[question.id.toString()]"
              placeholder="Select"
              :options="question.options"
              name="value"
              optionKey="id"
            />
            <a-radio-group v-else-if="question.type === 'rating'" v-model="form[question.id.toString()]">
              <a-radio v-for="option in question.options" :key="option.id" :value="option.id">
                {{ option.value }}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </div>
      </div>
    </div></a-form-model
  >
</template>

<script>
import { FormModel, Input, notification, Radio } from 'ant-design-vue'
import customSelectVue from './ui/custom-select.vue'

export default {
  components: {
    'a-form-model': FormModel,
    'a-form-model-item': FormModel.Item,
    'a-radio-group': Radio.Group,
    'a-radio': Radio,
    'a-input': Input,
    'custom-select': customSelectVue
  },
  props: {
    template: {
      type: Object,
      default: undefined
    },
    initialValue: {
      type: Object,
      default: undefined
    }
  },
  watch: {
    template: {
      handler(newVal) {
        if (!newVal || !newVal.sections) return

        this.form = {}
        this.rules = {}

        newVal.sections.forEach(formItem => {
          formItem.questions.forEach(q => {
            const key = q.id.toString()

            this.$set(this.form, key, q.type === 'multi_select' ? [] : '')

            if (q.required) {
              this.$set(this.rules, key, [
                {
                  required: true,
                  message: 'Field cannot be empty',
                  trigger: 'change'
                }
              ])
            }
          })
        })
      },
      immediate: true,
      deep: true
    },
    initialValue: {
      handler(newVal) {
        if (newVal && this.template) {
          const uniqueQuestionIds = new Map(
            this.template.sections
              .map(section => section.questions)
              .flat()
              .map(question => [question.id, question])
          )
          Object.entries(newVal).forEach(([key, value]) => {
            const question = uniqueQuestionIds.get(Number(key))

            if (!question) {
              console.warn(`No question found for key: ${key}`)
              return
            }

            this.$set(this.form, key, question.type === 'multi_select' ? value : value[0])
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      form: {},
      rules: {}
    }
  },

  methods: {
    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    async save() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          this.$emit('save', this.form, true)

          return
        }

        this.$emit('save', this.form, false)
      })
    }
  }
}
</script>

<style scoped>
.ant-row {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
}

.ant-form {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
}

h2,
h3 {
  margin: 0;
}
</style>
